
$(document).ready(function(){


  $(document).on('click', '.toggle_listlinks_mobile', function(){
    $(this).next().stop().toggleClass('active');
  });
	//EtsCustomJS.quickViewInit(); 
	$(".slideshow__text-content > *").each(function(){
      var effect_add = $(this).attr('data-effect');
      var effect_delay = $(this).attr('data-delay');
      
          $(this).delay(effect_delay).queue(function(){
            $(this).dequeue();
            $(this).addClass(effect_add);
            $(this).addClass('active');
          });
  	}); 
  
  if ($('#instafeed').length > 0){
  	var ins_user = parseInt($("#instafeed").attr("data-user"));
    var ins_token = $("#instafeed").attr("data-token");
    var ins_limit = parseInt($("#instafeed").attr("data-limit"));

    if ( ins_user != "" && ins_token != "" )
    {
        var userFeed = new Instafeed({
            get: 'user',
            limit: ins_limit,
            userId: ins_user,
            accessToken: ins_token
        });
        userFeed.run();
    }
  }
    
  
  
  click_show_hidden_sidebar();
    $(document).on('click', '.header_type_5 .dkmenu_toggler, .btn_close_menu', function(){
      $(this).parents('body').find('.header_bottom_menu').slideToggle(200);
    });

  	$(document).on('click', '.open-quick-view', function(){
  		var quickview_popup = $(this).attr('href');
  		$('body').find(quickview_popup).addClass('open');
  	});
  	$(document).on('click', '.close-quickview-popup', function(){
  		$('.quickview_popup').removeClass('open');
  	});

    $(window).load(function(){
        if ( $('#newsletter_success').length > 0 ){
          $("html, body").animate({ scrollTop: $('#newsletter_success').offset().top }, 2000);
        }
        if ( $('.errors').length > 0 ){
          $("html, body").animate({ scrollTop: $('.errors').offset().top }, 2000);
        }
    });
    
    
    $(window).load(function(){
      $('.ets_sub_menu_wrap a').each(function(){
        var linktitle = $(this).text();
        $(this).attr('title',linktitle);
      });
    });

  	$(document).on('click', '.variant_item span', function(){
  		if ( $(this).hasClass('selected')){
  			return false;
  		} else {
  			var datavalue = $(this).attr('data-value');
  			$(this).parents('.product-variants-item').find('span').removeClass('selected');
  			$(this).addClass('selected');
  			$(this).parents('.product-single__meta').find('option[value="'+datavalue+'"]').parent('select').find('option').removeAttr("selected","");
  			$(this).parents('.product-single__meta').find('option[value="'+datavalue+'"]').attr("selected","selected");
  			$(this).parents('.product-single__meta').find('option[value="'+datavalue+'"]').parent('select').val(datavalue);	
  			$(this).parents('.product-single__meta').find('option[value="'+datavalue+'"]').parent('select').change();
  		}
  	});

    $(document).on('click', '.filters-item li', function(){
      if ( $(this).hasClass('selected')){
        return false;
      } else {
        var datavalue1 = $(this).attr('data-title');
        $('#SortTags').find('option').removeAttr("selected","");
        $('#SortTags').find('option[data-title="'+datavalue1+'"]').attr("selected","selected");
        $('#SortTags').val();
        $('#SortTags').change();
      }
    });
    $(document).on('click', '.filters-item .remove_filter', function(){
      if ( $(this).hasClass('selected')){
        return false;
      } else {
        var dataremove = $(this).attr('data-title');
        $('#SortTags').find('option').removeAttr("selected","");
        $('#SortTags').find('option[value="'+dataremove+'"]').attr("selected","selected");
        $('#SortTags').val();
        $('#SortTags').change();
      }
    });



  	$(window).load(function(){
  		$('.product-single__meta select').each(function(){
  			var datavaluecurrent = $(this).find('option:selected').attr('value');
  			$(this).parents('.product-single__meta').find('.variant_item span[data-value="'+datavaluecurrent+'"]').addClass('selected');
  			
  		});
  	});

    $(document).on('click','.side_bar_title',function(){
      if ( $(window).width() < 768){
        $(this).stop().toggleClass('active').next().toggleClass('active');
        $(this).parent().next('.sidebar_content_block').stop().toggleClass('active');
      }
      
    });

  	$(document).on('click','.p_tab_title_link',function(e){
  		e.preventDefault();
  		if ($(this).hasClass('active')){
  			return false;
  		} else {
  			var data_tab = $(this).attr('href');
	  		$('.p_tab_title_link').removeClass('active');
	  		$('.p_tab_content .tab_panel').removeClass('active');
	  		$(this).addClass('active').parents('.p_tab').find(data_tab).addClass('active');
  		}
  		
  	});
  	// The button to increment the product value
	$(document).on('click', '.product_quantity_up', function(e){
		e.preventDefault();
		var currentVal = parseInt($('input#quantity').val());
		$('input#quantity').val(currentVal + 1).trigger('keyup');
		$('input#quantity').change();
	});

  $(document).on('click', '.cart_quantity_up', function(e){
    e.preventDefault();
    var cartcurrentVal = parseInt($(this).parent().prev('.cart__qty-input').val());
    $(this).parent().prev('.cart__qty-input').val(cartcurrentVal + 1).trigger('keyup');
    $(this).parent().prev('.cart__qty-input').change();
  });



  $(document).on('click', '.button_login_toogle_form', function(e){
    e.preventDefault();
    $(this).parent().find('.login_form_top').stop().toggleClass('active');
  });


  
	 // The button to decrement the product value
	$(document).on('click', '.product_quantity_down', function(e){
		e.preventDefault();
		var currentVal = parseInt($('input#quantity').val());
		if (currentVal > 1)
			$('input#quantity').val(currentVal - 1).trigger('keyup');
		else
			$('input#quantity').val(1);

		$('input#quantity').change();
	});

  $(document).on('click', '.cart_quantity_down', function(e){
    e.preventDefault();
    var cartcurrentVal = parseInt($(this).parent().prev('.cart__qty-input').val());
    if (cartcurrentVal > 1)
      $(this).parent().prev('.cart__qty-input').val(cartcurrentVal - 1).trigger('keyup');
    else
     $(this).parent().prev('.cart__qty-input').val(1);

    $(this).parent().prev('.cart__qty-input').change();

  });






$(window).load(function(){
  $('.plw_content').addClass('plw_page_loaded');
});


	
	if ($('.products_list_type_carousel').length > 0)
	{
    $(".products_list_type_carousel").each(function(){
        var hometab = $(this).attr('data-id');
        var itemcarousel = $(this).attr('data-show');
     
        $('#'+ hometab).find('.tab_collection_products').slick({
          infinite: true,
          slidesToShow: itemcarousel,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: itemcarousel,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: itemcarousel,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
    });
	}



  $('.thumbnails-wrapper:not(.thumbnails-slider_ver) .product-single__thumbnails').slick({
    slidesToShow: 4,
    infinite: true,
    slidesToScroll: 3,
    infinite: false,
    prevArrow: '.thumbnails-wrapper .slick-prev',
    nextArrow: '.thumbnails-wrapper .slick-next',
    responsive: [
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
  $('.thumbnails-wrapper.thumbnails-slider_ver .product-single__thumbnails').slick({
    slidesToShow: 4,
    infinite: true,
    slidesToScroll: 1,
    infinite: false,
    vertical: true,
    prevArrow: '.thumbnails-wrapper .slick-prev',
    nextArrow: '.thumbnails-wrapper .slick-next',
    responsive: [
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });


  if ($('.sidebar_block_type_slide').length > 0)
  {
    $('.sidebar_block_type_slide .sidebar_content_block').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

  if ($('.products_related .product').length > 0)
  {
    $('.products_related .product').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

	if ($('.blog_type_carousel').length > 0)
	{
		$('.blog_type_carousel').slick({
		  infinite: true,
		  slidesToShow: 3,
		  slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
		});
	}

  $(document).on('click', '.arow_mm', function(e){
    if ($(window).width() <= 767){
      $(this).toggleClass('active').next().stop().slideToggle(200);
      return false;
    }
  });
  $(document).on('click', '.toggle_menu', function(e){
    if ($(window).width() <= 767){
      $(this).toggleClass('active').next().stop().toggleClass('active');
      return false;
    }
  });
  $(document).on('click', '.footer_title', function(e){
    if ($(window).width() <= 767){
      $(this).toggleClass('active').next().stop().slideToggle('active');
      return false;
    }
  });
  scroll_top();
	dropDown();
  autosize_slider();
  $(window).resize(function(e){
    autosize_slider();
  });
  
  if (ets_getCookie('not_show_nlt')=='0' || ets_getCookie('not_show_nlt')==''){
    $('.popup_newletter').addClass('open');
  }
  $('.ynp-close, .fancybox-bg').on('click',function(){
    $('.popup_newletter').removeClass('open');
    if($('#ynp-input-dont-show').is(':checked')){
        setCookie("not_show_nlt", 1, 2);
    } else {
        setCookie("not_show_nlt", 0, 2);
    }
  });


  $('.sidebar_header').on('click', function(e){
      $('.sidebar_fixed').removeClass('open');
      $('.fixed_button').removeClass('hide');
  });
  $(document).mouseup(function (e)
    {
        var container_block_search = $('.sidebar_fixed.open .fixed_content');
        if (!container_block_search.is(e.target)&& container_block_search.has(e.target).length === 0)
        {
            $('.sidebar_fixed').removeClass('open');
            $('.fixed_button').removeClass('hide');
        }
    });


});
/* --------------------------------------------------------------------------------------------------------------------------
  * Click show or hidden siderbar full width cateogry page
  * ----------------------------------------------------------------------------------------------------------------------- */

  function click_show_hidden_sidebar() {
      
      $('.fixed_button').off().on('click', function(){
        $(this).toggleClass('hide').parent().toggleClass('open');
        return false;
      });

        
  }


function autosize_slider(){

  var slider_width = $('.slideshow-wrapper').attr('data-width');
  
  var slider_height = $('.slideshow-wrapper').attr('data-height');

  if ( $('.slideshow-wrapper').length > 0 ){
    if ( slider_width > 1170 ){
        if ($(window).width() <= 1170){
          var scale_slider_width = $('.slideshow-wrapper').width() / 1170;
        
          var new_slider_height = scale_slider_width * slider_height;
          $('.slideshow').css("height",new_slider_height + 'px');
        } else {
          var height_default = slider_height = $('.slideshow-wrapper').attr('data-height');
          $('.slideshow').css("height",height_default + 'px');
        }
    } else{
        if ( slider_width >= $(window).width() ){
          var scale_slider_width = $('.slideshow-wrapper').width() / slider_width;
          var new_slider_height = scale_slider_width * slider_height;
          $('.slideshow').css("height",new_slider_height + 'px');
        } else {
            $('.slideshow').css("height",slider_height + 'px');
            $('.slideshow').css("max-width",slider_width + 'px');
        }
    }
  }
} 
function setCookie(cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function scroll_top() {

  if ($('.scroll_top').length > 0) {
    var sticky_navigation_offset_top = 300;
    var sticky_scroll = function () {
      var scroll_top = $(window).scrollTop();
      if (scroll_top > sticky_navigation_offset_top) {
        $('.scroll_top').addClass('show_scroll');
      } else {
        $('.scroll_top').removeClass('show_scroll');
      }
    };

    sticky_scroll();

    $(window).scroll(function () {
      sticky_scroll();
    });

    $(document).on('click', '.scroll_top', function (e) {
      $("html, body").animate({scrollTop: 0}, "slow");
      return false;
    });
  }
}
function dropDown()
{
  elementClick = 'ets_button_toggle';
  elementSlide =  'ets_toogle_content';
  activeClass = 'active';

  $(elementClick).on('click', function(e){
    e.stopPropagation();
    var subUl = $(this).next(elementSlide);
    if(subUl.is(':hidden'))
    {
      subUl.slideDown();
      $(this).addClass(activeClass);
    }
    else
    {
      subUl.slideUp();
      $(this).removeClass(activeClass);
    }
    $(elementClick).not(this).next(elementSlide).slideUp();
    $(elementClick).not(this).removeClass(activeClass);
    e.preventDefault();
  });

  $(elementSlide).on('click', function(e){
    e.stopPropagation();
  });

  $(document).on('click', function(e){
    e.stopPropagation();
    var elementHide = $(elementClick).next(elementSlide);
    $(elementHide).slideUp();
    $(elementClick).removeClass('active');
  });
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function ets_getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}





 


